import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { connect, useSelector } from "react-redux";

import { gaugeLayout, getErrorMsg, getGaugeData } from "utils/gaugeUtils";
import parseWidgetData from "utils/widgetUtils";

import ErrorLabel from "components/ErrorLabel";
import PageLoading from "components/PageLoading/index.js";

import WidgetHeader from "./../WidgetHeader";

import "./index.css";

const Gauge = ({ item, onWidgetAction, isWidgetUpdating, systemsStatus }) => {
  const { SubType, Id, Attributes } = item;
  const { SystemTag } = Attributes;
  const { tagsAsObj } = useSelector(state => state.tags);
  const gaugeTag = tagsAsObj[SystemTag];
  const GaugeData = Attributes ? parseWidgetData(item, tagsAsObj).GaugeData : null;
  const { L, LL, H, HH } = GaugeData;
  const [data, setData] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    setIsUpdating(isWidgetUpdating);
  }, [isWidgetUpdating]);

  useEffect(() => {
    setData(getGaugeData(gaugeTag.Value, gaugeTag.Units, L, LL, H, HH, SubType));
  }, [item, gaugeTag.Value]);

  const getWidgetDesc = () => `${gaugeTag.TagId} | ${gaugeTag?.Description}`;

  const isValueError = () => {
    const { Value } = gaugeTag;
    return Value < LL.Value || Value > HH.Value;
  };

  const isSystemOfflineOrHasError = () =>
    //App crash sometime, need to check logic
    isValueError() && systemsStatus[0].connectionStatus === 0 && systemsStatus[0].systemStatus === 0;
  return (
    <>
      <div className={`cardContainer ${isValueError() ? "card-error" : ""}`}>
        {isUpdating ? (
          <PageLoading customHeight="200px" />
        ) : (
          <>
            <WidgetHeader title={gaugeTag.TagName} description={getWidgetDesc()} onWidgetAction={onWidgetAction} WidgetID={Id} />
            {isValueError() && <ErrorLabel message={getErrorMsg(isSystemOfflineOrHasError())} />}
            {!isSystemOfflineOrHasError() && (
              <div className="d-flex flex-center-center">{data && <Plot data={data} layout={gaugeLayout} config={{ displayModeBar: false }} />}</div>
            )}
          </>
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({ tags, poll }) => ({
  tagsList: tags.tags,
  systemsStatus: poll.systemsStatus
});

export default connect(mapStateToProps)(Gauge);
